export default "__VITE_ASSET__BHXglA7q__"